import React from "react";

function Adimayiruthal() {
    return (
        <div style={{ marginBottom: '100px' }}>
            <div className="row banner" style={{ backgroundImage: 'url(./images/makreri.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
            <div class="container">
                <div
                    className="container animated-border"
                    style={{
                        marginTop: '50px',
                        marginBottom: '50px',
                        background: 'white',
                        borderRadius: '15px'
                    }}
                >
                    <div className="row">
                        <div
                            className="col-12 col-md-5"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '25px'
                            }}
                        >
                            <img
                                src="./images/child.jpeg"
                                alt="Maruthi Temple"
                                style={{ width: '100%' }}
                            />
                        </div>

                        <div
                            className="col-12 col-md-7"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}

                        >
                            <h3 className="hheading" style={{ paddingLeft: '50px', paddingTop: '50px' }}>കുട്ടി​കളെ ഹനുമാൻ‍ സ്വാമിയുടെ നടയിൽ അടിമയിരുത്തുന്ന ചടങ്ങ്</h3>
                            <p className="about">
                                ശ്രീകൃഷ്ണമാരുതി ക്ഷേത്രത്തിലെ പ്രധാന ചടങ്ങാണ് കുട്ടികളെ അടിമയിരുത്തൽ. അടിമയിരുത്തുന്നത് വിദ്യാവർദ്ധനവിനും ബുദ്ധിഗുണത്തിനും ബാലാരിഷ്ടത മാറുന്നതിനും ഉത്തമമാണ്. <br />
                                ഹനുമാൻ സ്വാമിയുടെ നടയിൽ കുട്ടികളെ അടിമയിരുത്തുന്നതിലൂടെ കുട്ടിയും സ്വാമിയും തമ്മിൽ ഗുരുശിഷ്യ ബന്ധമുണ്ടാകുന്നു. കുട്ടിയുടെ ബാല്യം, കൗമാരം, യൗവനം, വാർദ്ധക്യം തുടങ്ങി ജീവിതാവസാനം വരെ ഹനുമാൻസ്വാമി കൂടെയുണ്ടാകണമെന്ന പ്രാർത്ഥനയോടെയാണ് കുട്ടികളെ അടിമയിരുത്തുന്നത്. തൻ്റെ രക്ഷയ്ക്ക് ഹനുമാൻ സ്വാമി എപ്പോഴും കൂടെയുണ്ടെന്ന വിശ്വാസം കുട്ടികളുടെ മനസ്സിൽ ഉണ്ടാക്കാൻ ഇത് സഹായിക്കും.വിജയത്തിലേക്കുള്ള യാത്രയിൽ കുട്ടികൾക്ക് മനോബലം വർദ്ധിക്കുവാൻ‍ സഹായിക്കും.  മീനമാസത്തിലെ രോഹിണി നക്ഷത്രത്തിലാണ് ഈ ചടങ്ങ്. ഒരു വയസിനു ശേഷം 10 വയസ് വരെ അടിമയിരുത്താം. <br />
                                ഏഴ് ദിവസം വ്രതം ആചരിക്കണം. ഒരു കിഴിപ്പണവും ഫലമൂലാദികളും സമർപ്പിച്ചാണ് ചടങ്ങ് നടത്തുന്നത്. മീനമാസിലെ രോഹിണി നക്ഷത്രത്തിൽ ആണ് അടിമയിരുത്തൽ ചടങ്ങ് നടക്കുന്നത്

                            </p>
                        </div>
                    </div>
                </div>




                


            </div>

        </div>
    );
}

export default Adimayiruthal;
